// RegisterStep5.js - com padronização ajustada conforme RegisterStep3

import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { updateStepData } from '../../Store/Actions/Partner';

import { useMediaQuery } from 'react-responsive';

import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import Grid from '@mui/material/Grid';

import { 
  maskPhone,
  maskCNPJ,
  maskCPF,
  maskCreditcard,
  maskCardExpiry,
  validateSingleField
} from '../../Components/Utils';

import visa_icon from '../../Assets/Images/visa_icon.svg';
import creditcard_icon from '../../Assets/Images/creditcard_icon.svg';

// Mapeamento das marcas para os ícones
const cardIcons = {
  visa: visa_icon,
  creditcard: creditcard_icon,
};

const RegisterStep5 = (props) => {

  const { 
    stepIndex, 
    stepData, 
    stepDataAll,
    updateStepData,
    stepValidations,
    setAlert,
    setAlertTitle,
    setAlertBody    
  } = props;

    console.log('stepDataAll STEP 5----------->'+JSON.stringify(stepDataAll,null,2));

  const formDataRef = useRef({});
  const [formFields, setFormFields] = useState({
    redirections: (() => {
      const defaults = stepData?.redirections || {};
      const firstService = stepDataAll[1]?.servicesOffered?.[0];
      if (firstService && defaults[firstService] == null) {
        defaults[firstService] = 10;
      }
      return defaults;
    })(),
    creditCardLater: stepData?.creditCardLater || false,
    cardNumber: stepData?.cardNumber || '',
    cardHolderName: stepData?.cardHolderName || '',
    cardHolderCpf: stepData?.cardHolderCpf || '',
    cardExpiry: stepData?.cardExpiry || '',
    cardCvv: stepData?.cardCvv || '',
    cardBrand: stepData?.cardBrand || 'creditcard',
    billingAddressSameAsBusiness: stepData?.billingAddressSameAsBusiness ?? true,
    useCompanyAddressForBilling: stepData?.useCompanyAddressForBilling ?? true,
    billingAddress: stepData?.billingAddress || {},
    billingDocument: stepData?.billingDocument || stepDataAll?.[0]?.companyDocument || ''
  });

  // const servicesSelected = stepDataAll[1]?.servicesOffered || [];
  const servicesSelected = stepDataAll[1]?.servicesOfferedFull || [];

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  React.useEffect(() => {
    const validIds = new Set(servicesSelected.map(s => s.id));
    const filteredRedirections = Object.fromEntries(
      Object.entries(formFields.redirections || {}).filter(([key]) => validIds.has(Number(key)))
    );
  
    // Atualiza se houver diferença
    const isDifferent = JSON.stringify(filteredRedirections) !== JSON.stringify(formFields.redirections);
    if (isDifferent) {
      handleFieldChange('redirections', filteredRedirections);
      updateStepData(stepIndex, { ...formDataRef.current, redirections: filteredRedirections });
    }
  }, [servicesSelected]);
  


  const [showRedirectHelp, setShowRedirectHelp] = useState(false);
  const [showIuguInfo, setShowIuguInfo] = useState(false);


  const handleFieldChange = (fieldName, value) => {
    setFormFields(prev => {
      const updated = { ...prev, [fieldName]: value };
  
      // ⚠️ Se for pular o cartão, limpamos os dados
      if (fieldName === 'creditCardLater' && value === true) {
        updated.cardNumber = 'SKIPPED';
        updated.cardHolderName = 'SKIPPED';
        updated.cardExpiry = '01/30';
        updated.cardCvv = '000';
        updated.cardHolderCpf = '00000000000';
      }
  
      if (fieldName === 'creditCardLater' && value === false) {
        updated.cardNumber = '';
        updated.cardHolderName = '';
        updated.cardExpiry = '';
        updated.cardCvv = '';
        updated.cardHolderCpf = '';
      }
  
      // ⚠️ Se endereço for igual ao do negócio, limpamos os campos manuais
      if (fieldName === 'billingAddressSameAsBusiness' && value === true) {
        updated.billingAddress = {
          address: 'SAME',
          number: 'SAME',
          complement: '',
          neighborhood: 'SAME',
          city: 'SAME',
          uf: 'RJ' // ✅ seta 'RJ' para satisfazer a obrigatoriedade
        };
      }
  
      if (fieldName === 'billingAddressSameAsBusiness' && value === false) {
        updated.billingAddress = {
          address: '',
          number: '',
          complement: '',
          neighborhood: '',
          city: '',
          uf: ''
        };
      }

      if (fieldName === 'billingAddressSameAsBusiness') {
        updated.useCompanyAddressForBilling = value;
      }      
  
      formDataRef.current = updated;
      return updated;
    });
  
    formDataRef.current[fieldName] = value;
  };
  

  const handleBlur = () => {
    updateStepData(stepIndex, { ...formDataRef.current });
  };

  const handleRedirectionChange = (serviceId, value) => {
    const updated = {
      ...formFields.redirections,
      [serviceId]: value ?? 0  // <- permite 0
    };
    handleFieldChange('redirections', updated);
  };

  const renderRedirectionInput = (service, idx) => {

    const serviceName = service.name;
    const serviceId = service.id;
    const isRequired = service.required === 1;
    const minQuantity = isRequired ? service.lead?.[0]?.leadMinQuantity || 10 : 0;
    const currentValue = formFields.redirections[serviceId] ?? minQuantity;
    const perLeadPrice = service.lead?.[0]?.perLeadPrice ?? 15;
    const servicePriceOf = service.lead?.[0]?.servicePriceOf || 'R$ 250,00';
    const servicePriceFor = service.lead?.[0]?.servicePriceFor || 'R$ 129,00';

    return (
      <div
        key={serviceId}
        className="leadConfig w100 flex-row justify-between align-items-center"
        style={{ gap: "0.5rem", padding: "0.5rem 0" }}
      >
        <div className="flex-1 tAlignL serviceName">
          {serviceName} <br />
          <small className="fLight">Valor a ser cobrado do cliente <br /> De: <strike>{servicePriceOf}</strike> por: {servicePriceFor} </small>
        </div>
        <div className="tAlignR serviceQuantity">
          <InputNumber
            value={currentValue}
            onValueChange={(e) => {
              handleRedirectionChange(serviceId, e.value ?? 0); // sem Math.max
            }}
            showButtons
            min={minQuantity}
            disabled={false} // você pode colocar `isRequired` se quiser bloquear
            className="serviceLeadQuantity"
            onBlur={handleBlur}
            inputStyle={{ width: "3rem", height: "2rem", textAlign: "center" }}
            placeholder="Qtd"
          />
        </div>
        <div className="priceTag tAlignR" style={{ marginLeft: "10px" }}>
          R$ {Number(perLeadPrice).toFixed(2)}
        </div>
      </div>
    );
  };  
  
  // gera totalizador de direcionamentos
  const totalRedirections = React.useMemo(() => {
    return Object.values(formFields.redirections || {})
      .map(val => parseInt(val))
      .filter(val => !isNaN(val))
      .reduce((acc, val) => acc + val, 0);
  }, [formFields.redirections]);

  const ufs = [
    { label: 'AC', value: 'AC' }, { label: 'AL', value: 'AL' }, { label: 'AP', value: 'AP' },
    { label: 'AM', value: 'AM' }, { label: 'BA', value: 'BA' }, { label: 'CE', value: 'CE' },
    { label: 'DF', value: 'DF' }, { label: 'ES', value: 'ES' }, { label: 'GO', value: 'GO' },
    { label: 'MA', value: 'MA' }, { label: 'MT', value: 'MT' }, { label: 'MS', value: 'MS' },
    { label: 'MG', value: 'MG' }, { label: 'PA', value: 'PA' }, { label: 'PB', value: 'PB' },
    { label: 'PR', value: 'PR' }, { label: 'PE', value: 'PE' }, { label: 'PI', value: 'PI' },
    { label: 'RJ', value: 'RJ' }, { label: 'RN', value: 'RN' }, { label: 'RS', value: 'RS' },
    { label: 'RO', value: 'RO' }, { label: 'RR', value: 'RR' }, { label: 'SC', value: 'SC' },
    { label: 'SP', value: 'SP' }, { label: 'SE', value: 'SE' }, { label: 'TO', value: 'TO' }
  ];

  return (
    <div style={{ width: '100%' }}>

        <Panel header="Seleção de direcionamentos" style={{ marginBottom: '20px', border: 0 }}>

          <div className="leadBox">

              <div className="call">PAGUE APENAS PELOS DIRECIONAMENTOS RECEBIDOS</div>

                <div className="redirectIntro">
                  <p><span className="bold">Indique abaixo a quantidade de cada tipo de direcionamento que deseja receber por mês.</span> Há o mínimo de 10 direcionamentos para consulta oftalmológica.</p>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <div className="leadConfig w100 flex-row justify-between align-items-center" style={{ gap:"0.5rem", padding: '0.5rem 0' }}>
                    <div className="tableTitle flex-1 tAlignL serviceName">Tipo de direcionamento</div>
                    <div className="tableTitle flex-1 tAlignR serviceName">Qtde e Valor por direcionamento</div>                    
                  </div>                  
                  {servicesSelected.map((service, idx) => (
                    <>
                      {renderRedirectionInput(service,idx)}
                    </>
                  ))}
                </div>

                <div className="redirectSummary w100 flex-row justify-between align-items-center " style={{ gap:"0.5rem", padding: '0.5rem 0', marginTop:"1rem" }}>
                    <div className="tableFooter flex-1 tAlignL serviceName">Total máximo de direcionamentos:</div>
                    <div className="tableFooter flex-1 tAlignR serviceName">{totalRedirections} direcionamentos</div>                  
                </div>  
                 

                <div className="redirectHelp">
                  <span className="clickableLink applyPointer" onClick={() => setShowRedirectHelp(true)}>Tem dúvida sobre o que é direcionamento?</span><span className="icon">!</span>
                </div>

          </div>
      </Panel>

      <Panel className="creditCardBlock" header="Cartão de crédito" style={{ marginBottom: '20px', border: 0 }}>

        <div className="creditCardDisclaimer tAlignL">
          <span className="fLight">
            🔒 Seus dados estão seguros. As informações do cartão não serão armazenadas conosco. Apenas armazenaremos um token referencial para cobranças futuras.
            Todo o processo é realizado com segurança pela {' '}
            <span className="clickableLinkCC" onClick={() => setShowIuguInfo(true)}>
              IUGU
            </span>
            {' '} , nosso parceiro de pagamentos.
          </span>
        </div>

        <Grid container spacing={4}>
          <Grid item xs={12}>

            <div className="warningText"></div>

            <div className="w100 tAlignL formControl flex-row align-items-center justify-start" style={{ gap: '0.5rem'}}>
              <Checkbox
                inputId="creditCardLater"
                checked={formFields.creditCardLater}
                onChange={(e) => {
                  handleFieldChange('creditCardLater', e.checked);
                  handleFieldChange('cardToken', null); // added to clean any existing cardtoken
                  handleBlur(); // <-- adiciona essa linha
                }}
              />
              <label htmlFor="creditCardLater" style={{ marginLeft: 8, marginBottom:0 }}>Preencher cartão depois</label>
            </div>

            {formFields.creditCardLater && (
              <div className="warningText">
                <i className="pi pi-exclamation-triangle" style={{ marginRight: '0.5rem', color: '#fbc02d' }}></i>
                Você pode preencher os dados do cartão depois, mas não poderá receber direcionamentos até que o faça.
              </div>
            )}

          </Grid>
          {!formFields.creditCardLater && (
            <>
              <Grid item xs={12} sm={12}>
                <div className="w100 tAlignL formControl" style={{ position: 'relative' }}>
                  <label htmlFor="cardNumber">Número do cartão <span className="requiredField">*</span></label>
                  <InputText
                    id="cardNumber"
                    value={formFields.cardNumber}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, '');
                      const masked = maskCreditcard(rawValue);
                      handleFieldChange('cardNumber', masked);
                      
                      // 🔍 Detectar bandeira
                      if (/^4/.test(rawValue)) handleFieldChange('cardBrand', 'visa');
                      else if (/^5[1-5]/.test(rawValue)) handleFieldChange('cardBrand', 'mastercard');
                      else if (/^3[47]/.test(rawValue)) handleFieldChange('cardBrand', 'amex');
                      else if (/^6(?:011|5)/.test(rawValue)) handleFieldChange('cardBrand', 'discover');
                      else handleFieldChange('cardBrand', 'creditcard');
                    }}
                    onBlur={() => {
                      handleBlur();
                      const error = validateSingleField(stepValidations, 'cardNumber', formFields.cardNumber);
                      if (error) {
                        setAlert(true);
                        setAlertTitle('Verifique o número do cartão');
                        setAlertBody(error);
                      }
                    }}
                    className="w100"
                    placeholder="**** **** **** ****"
                    style={{ paddingRight: '3rem' }}
                    maxLength={formFields.cardBrand == 'amex' ? 18 : 19} // 16 digits + 3 spaces
                  />

                  {formFields.cardBrand && (
                    <img
                      src={cardIcons[formFields.cardBrand]}
                      alt={formFields.cardBrand}
                      style={{
                        position: 'absolute',
                        right: '15px',
                        top: '35%',
                        height: '40px',
                        pointerEvents: 'none'
                      }}
                    />
                  )}
                  <small className="fLight">Não aceitamos cartões de crédito virtuais de uso único.</small>                  
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="cardHolderName">Nome impresso no cartão <span className="requiredField">*</span></label>
                  <InputText
                    id="cardHolderName"
                    value={formFields.cardHolderName}
                    onChange={(e) => handleFieldChange('cardHolderName', e.target.value)}
                    onBlur={() => {
                     handleBlur();
                      const error = validateSingleField(stepValidations, 'cardHolderName', formFields.cardHolderName);
                      if (error) {
                        setAlert(true);
                        setAlertTitle('Verifique o nome do cartão');
                        setAlertBody(error);
                      }
                    }}
                    placeholder="Nome como impresso no cartão"
                    className="w100"
                  />
                </div>
              </Grid>
              <Grid item xs={8}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="cardExpiry">Validade <span className="requiredField">*</span></label>
                  <InputText
                  id="cardExpiry"
                  value={formFields.cardExpiry}
                  onChange={(e) => {
                    const masked = maskCardExpiry(e.target.value);
                    handleFieldChange('cardExpiry', masked);
                  }}
                  onBlur={() => {
                    handleBlur();
                     const error = validateSingleField(stepValidations, 'cardExpiry', formFields.cardExpiry);
                     if (error) {
                       setAlert(true);
                       setAlertTitle('Verifique a data de expiração do cartão');
                       setAlertBody(error);
                     }
                   }}
                  className="w100"
                  placeholder="MM/AA"
                  maxLength={5}
                />
                </div>
              </Grid>
              <Grid item xs={4}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="cardCvv">CVV <span className="requiredField">*</span></label>
                  <InputText
                    id="cardCvv"
                    value={formFields.cardCvv}
                    onChange={(e) => handleFieldChange('cardCvv', e.target.value)}
                    onBlur={() => handleBlur()}
                    className="w100"
                    maxLength={formFields.cardBrand === 'amex' ? 4 : 3}
                    placeholder="CVV"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="cardHolderCpf">CPF do proprietário <span className="requiredField">*</span></label>
                  <InputText
                    id="cardHolderCpf"
                    value={formFields.cardHolderCpf}
                    onChange={(e) => {
                      const masked = maskCPF(e.target.value);
                      handleFieldChange('cardHolderCpf', masked);
                    }}                    
                    onBlur={() => {
                      handleBlur();
                       const error = validateSingleField(stepValidations, 'cardHolderCpf', formFields.cardHolderCpf);
                       if (error) {
                         setAlert(true);
                         setAlertTitle('Verifique o CPF do proprietário do cartão');
                         setAlertBody(error);
                       }
                     }}
                    className="w100"
                    tooltip='Digite apenas números'
                    tooltipOptions={{ position: 'bottom',event:'focus' }}
                    placeholder="000.000.000-00"                    
                  />
                </div>
              </Grid>              
              <Grid item xs={12}>
                <div className="w100 tAlignL disclaimerText">
                * Será realizada uma cobrança de R$ 2,00, com estorno imediato, para confirmação do cartão.
                </div>
              </Grid>
            </>
          )}
        </Grid>
      </Panel>

      <Panel header="Dados de faturamento" style={{ marginBottom: '20px', border: 0 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
          <div className="w100 tAlignL formControl flex-row align-items-center justify-start" style={{ gap: '0.5rem' }}>
              <Checkbox
                inputId="billingAddressSameAsBusiness"
                checked={formFields.billingAddressSameAsBusiness}
                onChange={(e) => {
                  handleFieldChange('billingAddressSameAsBusiness', e.checked);
                  handleBlur(); // <-- adiciona essa linha
                }}
              />
              <label htmlFor="billingAddressSameAsBusiness" style={{ marginLeft: 8, marginBottom:0 }}>O endereço de faturamento é igual ao endereço do negócio</label>
            </div>
          </Grid>

          {(!formFields.billingAddressSameAsBusiness) && (
            <>
              <Grid item xs={12}>
              
              <div className="w100 tAlignL formControl" style={{marginBottom:"1.5rem"}}><label style={{fontWeight:"bold"}}>Endereço de faturamento<span className="requiredField">*</span></label></div>

                <div className="w100 tAlignL formControl">
                  <label htmlFor="address">Logradouro<span className="requiredField">*</span></label>
                  <InputText
                    id="address"
                    value={formFields.billingAddress.address || ''}
                    onChange={(e) => handleFieldChange('billingAddress', { ...formFields.billingAddress, address: e.target.value })}
                    className="w100"
                    placeholder="Rua, Avenida, etc."
                    onBlur={() => handleBlur()}
                  />
                </div>
              </Grid>
              <Grid item xs={6}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="number">Número</label>
                  <InputText
                    id="number"
                    value={formFields.billingAddress.number || ''}
                    onChange={(e) => handleFieldChange('billingAddress', { ...formFields.billingAddress, number: e.target.value })}
                    onBlur={() => handleBlur()}
                    className="w100"
                  />
                </div>
              </Grid>
              <Grid item xs={6}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="complement">Complemento</label>
                  <InputText
                    id="complement"
                    value={formFields.billingAddress.complement || ''}
                    onChange={(e) => handleFieldChange('billingAddress', { ...formFields.billingAddress, complement: e.target.value })}
                    onBlur={() => handleBlur()}
                    className="w100"
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="neighborhood">Bairro <span className="requiredField">*</span></label>
                  <InputText
                    id="neighborhood"
                    value={formFields.billingAddress.neighborhood || ''}
                    onChange={(e) => handleFieldChange('billingAddress', { ...formFields.billingAddress, neighborhood: e.target.value })}
                    onBlur={() => handleBlur()}
                    className="w100"
                  />
                </div>
              </Grid>
              <Grid item xs={8}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="city">Cidade <span className="requiredField">*</span></label>
                  <InputText
                    id="city"
                    value={formFields.billingAddress.city || ''}
                    onChange={(e) => handleFieldChange('billingAddress', { ...formFields.billingAddress, city: e.target.value })}
                    onBlur={() => handleBlur()}
                    className="w100"
                  />
                </div>
              </Grid>
              <Grid item xs={4}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="uf">UF <span className="requiredField">*</span></label>
                  <Dropdown
                    id="uf"
                    value={formFields.billingAddress.uf || ''}
                    options={ufs}
                    onChange={(e) => {handleFieldChange('billingAddress', { ...formFields.billingAddress, uf: e.value });handleBlur()}}
                    className="w100"
                    placeholder="UF"
                  />
                </div>
              </Grid>
            </>
          )}
              <Grid item xs={12}>
                <div className="w100 tAlignL formControl">
                  <label htmlFor="cnpj">CNPJ de faturamento <span className="requiredField">*</span></label>
                  <InputText
                    id="cnpj" 
                    value={formFields.billingDocument || ''}
                    onChange={(e) => {
                      const masked = maskCNPJ(e.target.value);
                      handleFieldChange('billingDocument', masked);
                    }}
                    onBlur={() => {
                      handleBlur();
                       const error = validateSingleField(stepValidations, 'billingDocument', formFields.billingDocument);
                       if (error) {
                         setAlert(true);
                         setAlertTitle('Verifique o CNPJ de faturamento');
                         setAlertBody(error);
                       }
                     }}
                    className="w100"
                    tooltip='Digite apenas números'
                    tooltipOptions={{ position: 'bottom',event:'focus' }}
                    placeholder="00.000.000/0000-00"
                  />
                  <small className="fLight">Se precisar, altere o CNPJ de faturamento do serviço.</small>
                </div>
              </Grid>          
        </Grid>
      </Panel>

      <Dialog header="O que é um direcionamento?" visible={showRedirectHelp} style={{ width: isMobile ? '90vw' : '50vw', maxWidth: '600px' }} modal onHide={() => setShowRedirectHelp(false)}  closeOnEscape={true} dismissableMask={true}>
    <div style={{ padding: '1rem', lineHeight: '1.6' }}>
      <p>Um <strong>direcionamento</strong> é uma indicação de paciente enviada pela Estação do Olho para sua clínica. Você só paga quando recebe um contato válido, com dados confirmados e que tenha interesse no seu serviço.</p>
      <p><strong>Exemplo:</strong> Você contrata 15 direcionamentos de consulta oftalmológica. Ao longo do mês, até 15 pacientes que se encaixem nesse perfil serão direcionados à sua unidade.</p>
    </div>
    </Dialog>    

      <Dialog
        header="Sobre a IUGU"
        visible={showIuguInfo}
        closeOnEscape={true}
        dismissableMask={true}
        onHide={() => setShowIuguInfo(false)}
        style={{ width: isMobile ? '90vw' : '50vw' }}
        modal
      >
        <p>
          A IUGU é uma plataforma brasileira de pagamentos especializada em soluções para negócios digitais.
          É certificada com os mais altos padrões de segurança (PCI DSS) e realiza o processamento e armazenamento
          dos dados sensíveis do cartão, garantindo a proteção das suas informações financeiras.
        </p>
        <p>
          Saiba mais em: <a href="https://iugu.com" target="_blank" rel="noreferrer">https://iugu.com</a>
        </p>
      </Dialog>      

    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  stepData: state.partnerReducer.stepData[ownProps.stepIndex],
  stepDataAll: state.partnerReducer.stepData,
});


const mapDispatchToProps = {
  updateStepData
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterStep5);
